module.exports = __webpack_public_path__ + "img/xinruiheng.11b1410.png";